import { ESignStatus } from "@hereby/core/enums";

// 로컬 기준 종결 상태 — 서버 e-sign.state 의 LOCAL_TERMINAL 과 같은 집합.
// 종결된 레코드는 Hereby 에 다시 물어도 갱신되지 않으므로 목록 새로고침 동기화 대상에서 뺀다.
export const ESIGN_LOCAL_TERMINAL_STATUSES = new Set<string>([
  ESignStatus.SIGNED,
  ESignStatus.REJECTED,
  ESignStatus.EXPIRED,
]);

/** 목록 새로고침 때 Hereby 상태를 다시 확인할 레코드 id. contractId 가 없거나 종결된 건은 제외한다. */
export function esignSyncCandidateIds(records: readonly Record<string, unknown>[]): string[] {
  return records
    .filter(
      (r) =>
        typeof r.id === "string" &&
        !!r.herebyContractId &&
        !ESIGN_LOCAL_TERMINAL_STATUSES.has(String(r.status)),
    )
    .map((r) => r.id as string);
}
